import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import React from 'react'

import {
  BrandSelector,
  type BrandSelectorProps,
} from '~/components/features/BrandSelector'
import { useLogEvent } from '~/hooks/useLogEvent'
import {
  type Brand,
  useSurveyQueryActiveBrandGroup,
} from '~/hooks/useSurveyQuery'

import { brand1IdAtom, brand2IdAtom, isPendingTabulationAtom } from '../atoms'

export const Brand2SelectorContainer = () => {
  const logEvent = useLogEvent()

  const brandGroup = useSurveyQueryActiveBrandGroup()

  const brand1Id = useAtomValue(brand1IdAtom)
  const [brand2Id, setBrand2Id] = useAtom(brand2IdAtom)

  const setIsPendingTabulation = useSetAtom(isPendingTabulationAtom)

  const unselectedBrands = React.useMemo<BrandSelectorProps<Brand>['brands']>(
    () => brandGroup?.brands.filter((brand) => brand.id !== brand1Id, []) ?? [],
    [brand1Id, brandGroup?.brands],
  )

  const handleChange = React.useCallback<
    EH<BrandSelectorProps<Brand>, 'onChange'>
  >(
    (brandId) => {
      setBrand2Id(brandId)
      setIsPendingTabulation(false)

      const brand = brandGroup?.brands.find((brand) => brand.id === brandId)
      logEvent('Select brand 2 for overlap', {
        eventProperties: [
          { key: 'name', value: brand?.name ?? '' },
          { key: 'number', value: `${brand?.number}` },
        ],
      })
    },
    [brandGroup?.brands, logEvent, setBrand2Id, setIsPendingTabulation],
  )

  return (
    <BrandSelector
      brands={unselectedBrands}
      disabled={unselectedBrands.length === 0}
      value={brand2Id}
      width={360}
      onChange={handleChange}
    />
  )
}
